import { Fragment, useEffect, useState, useRef, useCallback } from "react";
import showAlert from "../../../server/ShowAlert";
import { BaseUrl } from "../../../../axiosInstance";
import { useSelector } from "react-redux";
import { GetMosadDetails } from "../../../server/Payment";

const PayNedarim = ({
  save,
  total,
  ClosePayPopup,
  numPayments,
  numPaymentSelect,
  orderIdInNedarim,
  pay,
  handleDebitTokenPayment,
}) => {
  const user = useSelector((state) => state.user.user);
  const iframeRef = useRef(null);
  const [isPaymentInProgress, setIsPaymentInProgress] = useState(false);
  const isPaymentBlockedRef = useRef(false);
  const [, setToken] = useState(null);
  const tokef = useRef(null);
  const CVV = useRef(null);
  const [mosad, setMosad] = useState("");
  const [apiValid, setApiValid] = useState("");
  const handlePaymentRef = useRef(handleDebitTokenPayment);

  useEffect(() => {
    handlePaymentRef.current = handleDebitTokenPayment;
  }, [handleDebitTokenPayment]);

  useEffect(() => {
    GetMosadDetails()
      .then((response) => {
        if (response.data) {
          setMosad(response.data["Mosad"]);
          setApiValid(response.data["ApiValid"]);
        }
      })
      .catch((error) => {
        console.error("Error fetching Mosad details:", error);
      });
  }, []);

  const setTokenAsync = useCallback((value) => {
    return new Promise((resolve) => {
      setToken(value);
      resolve(value);
    });
  }, []);

  useEffect(() => {
    const receivingMessages = async (e) => {
      if (e.origin === "https://www.matara.pro") {
        if (e.data && typeof e.data.Value.Status === "string") {
          switch (e.data.Value.Status) {
            case "OK":
              if (e.data.Value.Token) {
                const newToken = await setTokenAsync(e.data.Value.Token);
                handlePaymentRef.current(newToken, total, tokef.current);
              }
              break;
            case "Error":
              showAlert({
                msgTitle: "העסקה נכשלה",
                msgText: `שגיאה: ${e.data.Value.Message}`,
                msgType: "error",
              });
              isPaymentBlockedRef.current = false;
              setIsPaymentInProgress(false);
              ClosePayPopup(false);
              break;
            default:
              console.warn("Unexpected message received:", e.data);
              isPaymentBlockedRef.current = false;
              setIsPaymentInProgress(false);
          }
        }
      }
    };

    window.addEventListener("message", receivingMessages);
    return () => {
      window.removeEventListener("message", receivingMessages);
    };
  }, [ClosePayPopup, handleDebitTokenPayment, setTokenAsync, total]);

  const PostNedarim = (Data) => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage(Data, "*");
    } else {
      showAlert({
        msgTitle: "Error",
        msgText: "Could not load payment iframe.",
        msgType: "error",
      });
      isPaymentBlockedRef.current = false;
      setIsPaymentInProgress(false);
      return;
    }
  };

  const handlePayment = () => {
    if (isPaymentBlockedRef.current) return;
    isPaymentBlockedRef.current = true;
    setIsPaymentInProgress(true);

    const paymentData = {
      Name: "FinishTransaction2",
      Value: {
        Mosad: mosad,
        ApiValid: apiValid,
        Zeout: user.Id,
        FirstName: user.Name,
        LastName: user.LastName,
        City: user.City,
        Phone: user.Phone,
        Mail: user.Email,
        PaymentType: "CreateToken",
        Amount: total,
        Tashlumim: numPaymentSelect,
        Currency: "1",
        Groupe: "",
        Comment: "ללא כתובת למשלוח!",
        Param1: "",
        CallBack: `${BaseUrl}`,
      },
    };
    PostNedarim(paymentData);
  };

  const handleInputChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length > 2) {
      value = value.slice(0, 2) + "/" + value.slice(2);
    }
    tokef.current = value;
    e.target.value = value;
  };

  return (
    <Fragment>
      <div className="payment-form">
        {/* Card number — Nedarim iframe (user types directly; gateway tokenises) */}
        <div className="field">
          <label>מספר כרטיס אשראי</label>
          <div className="pn-iframe-wrap">
            <iframe
              id="NedarimFrame"
              ref={iframeRef}
              title="pay"
              src={`https://www.matara.pro/nedarimplus/iframe?Tokef=Hide&CVV=Hide&Picture=Hide&retdigits=1&HideCCLabel=1`}
            />
          </div>
        </div>

        {/* Expiry */}
        <div className="field">
          <label>תוקף כרטיס האשראי</label>
          <input
            className="textBox pn-input"
            type="text"
            inputMode="numeric"
            onChange={handleInputChange}
            placeholder="MM/YY"
            maxLength="5"
            autoComplete="cc-exp"
            dir="ltr"
          />
        </div>

        {/* CVV */}
        <div className="field">
          <label>3 ספרות בגב הכרטיס</label>
          <input
            className="textBox pn-input"
            type="text"
            inputMode="numeric"
            onChange={(e) => {
              CVV.current = e.target.value;
            }}
            placeholder="CVV"
            maxLength="4"
            autoComplete="cc-csc"
            dir="ltr"
          />
        </div>
      </div>
      <div className="btn-wrapper">
        <button
          className={`paymentBtn ${isPaymentInProgress ? "disabled" : ""}`}
          onClick={handlePayment}
          disabled={isPaymentInProgress}
        >
          {isPaymentInProgress ? "ממתין..." : "תשלום"}
        </button>
      </div>
    </Fragment>
  );
};

export default PayNedarim;
